export default class HeaderHandler {
    constructor(headers) {
        this.setHeaders(headers);
        this.vue = window.AppKit.getApp();
    }

    /**
     * get headers
     * @returns {*}
     */
    getHeaders() {
        return this.headers;
    }

    /**
     * Set headers
     * @param headers
     */
    setHeaders(headers) {
        this.headers = headers;
    }

    /**
     * Get all the supported headers options for a blueprint
     * @param bluerpintId
     * @returns {Promise<[{name: string, description: string, id: string},{name: string, description: string, id: string},{name: string, description: string, id: string}]>}
     */
    async getSupportedHeaders() {
        const url = await this.vue.$getSetting('paths.baseBlueprint') + '/http-headers/supported';
        return await this.vue.$get(url);
    }
}